import React from "react";
import { theme } from "antd";
import { useTranslate } from "@refinedev/core";
import { DocumentUploadArea } from "./DocumentUploadArea";
import { Sidebar, StepEyebrow, Title } from "./ContentSidebar.styles";

/**
 * Step 1 of the flow: add the documents the experience is generated from.
 * The upload area (drag/drop + browse, reorderable/removable file list) is
 * shared with the "Create now" blocked modal — see `DocumentUploadArea`.
 */
export const ContentSidebar: React.FC = () => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Sidebar $token={token}>
      <StepEyebrow $token={token}>
        {t("createExperience.step1.eyebrow")}
      </StepEyebrow>
      <Title $token={token}>{t("createExperience.step1.title")}</Title>

      <DocumentUploadArea />
    </Sidebar>
  );
};
